import type { SVGProps } from 'react';

const SvgAnnotationMove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20.92 12.38a1 1 0 0 0-.22-1.09l-2.5-2.5a.996.996 0 1 0-1.41 1.41l.79.79h-4.59V6.4l.79.79c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-2.5-2.5a1 1 0 0 0-1.42 0l-2.5 2.5a.996.996 0 1 0 1.41 1.41l.79-.79v4.59H6.39l.79-.79a.996.996 0 1 0-1.41-1.41l-2.5 2.5a1 1 0 0 0 0 1.42l2.5 2.5c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41l-.79-.79h4.59v4.59l-.79-.79a.996.996 0 1 0-1.41 1.41l2.5 2.5c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08.23-.12.33-.22l2.5-2.5a.996.996 0 1 0-1.41-1.41l-.79.79v-4.59h4.59l-.79.79a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l2.5-2.5c.09-.09.17-.2.22-.33z"
    />
  </svg>
);
export default SvgAnnotationMove;
